import "rxjs/add/operator/map";
import { Injectable } from "@angular/core";
// import { Http, Response, Headers } from "@angular/http";
import { HttpClient } from '@angular/common/http';
import { environment } from "../../../environments/environment";
import { UserService } from "./user.service";

@Injectable()
export class AuthenticationService {
    private server = environment.server;

    constructor(private http: HttpClient, private userService: UserService) {
    }

    login(email: string, password: string) {
        return this.userService.login(email, password);
        // return this.http.post(this.server + '/users/login', { userid: email, password: password })
        //     .map((result: any) => {
        //         // login successful if there's a jwt token in the response
        //         if (result.results instanceof Array && result.results.length) {
        //             const user = result.results[0];
        //             if (user && user.token) {
        //                 // store user details and jwt token in local storage to keep user logged in between page refreshes
        //                 localStorage.setItem('currentUser', JSON.stringify(user));
        //             }
        //         }
        //     });
    }

    // login(email: string, password: string) {
    //     return this.http.post('/api/authenticate', JSON.stringify({ email: email, password: password }))
    //         .map((response: Response) => {
    //             // login successful if there's a jwt token in the response
    //             let user = response.json();
    //             if (user && user.token) {
    //                 // store user details and jwt token in local storage to keep user logged in between page refreshes
    //                 localStorage.setItem('currentUser', JSON.stringify(user));
    //             }
    //         });
    // }

    logout() {
        return this.userService.logout();
        // remove user from local storage to log user out
        // localStorage.removeItem('currentUser');
        // localStorage.removeItem('level');
    }
}


// WEBPACK FOOTER //
// ./src/app/auth/_services/authentication.service.ts